import {format} from 'date-fns'

declare const __ENV__: undefined | {
    BACKEND_URL?: string
    RAVEN_DSN?: string
}

export const dev = process.env.NODE_ENV !== 'production'
export const dsn = __ENV__?.RAVEN_DSN ?? process.env.RAVEN_DSN ?? undefined //'https://1406a57afa594482aa9569f5b2d81c7c@o48617.ingest.sentry.io/104134'
export const version = process.env.VERSION ?? ''
export const commit = process.env.COMMIT ?? ''
export const server = __ENV__?.BACKEND_URL ?? process.env.BACKEND_URL ?? 'https://api-dev.ppl.do/graphql'
export const buildDate = process.env.BUILD_DATE ?? new Date(0).toISOString()

const ymd = format(new Date(buildDate), 'yy-MM-dd')

export const release = version + '.' + commit.slice(0, 8) + '-' + ymd
